var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCloneOptions({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 6H22.5V3C22.5 2.17 21.83 1.5 21 1.5H18V3H21V6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 1.5H12.75V3H15.75V1.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 8.25H21V11.25H22.5V8.25Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 13.5V16.5H18V7.5C18 6.67 17.33 6 16.5 6H7.5V3H10.5V1.5H7.5C6.67 1.5 6 2.17 6 3V6H3C2.17 6 1.5 6.67 1.5 7.5V21C1.5 21.83 2.17 22.5 3 22.5H16.5C17.33 22.5 18 21.83 18 21V18H21C21.83 18 22.5 17.33 22.5 16.5V13.5H21ZM16.5 21H3V7.5H16.5V21Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloneOptions);
export default __webpack_public_path__ + "static/media/ic-clone-options.2e9c02b075e814ca005bb56f07892293.svg";
export { ForwardRef as ReactComponent };